import React, { Component } from 'react';
import { Badge } from 'reactstrap';
import { connect } from "react-redux";
import {setSelectedRecord} from 'actions/index.js';

class DiscogsSearchResult extends Component {
    render() {
        let id= '';
        if (this.props.result === this.props.selectedRecord) {
            id = 'selected-record';
        }
        return (
            <div
              onClick={() => this.props.setSelectedRecord(this.props.result)}
              className="discogs-result record">
              <img
                id={id}
                className="discogs-thumbnail" src={this.props.result.thumb}/>
              <div className="record-info">
                <div className="title">
                  {this.props.result.title}
                </div>
                <div className="year">
                  {this.props.result.year}
                </div>
                <div className="styles">
                  {this.props.result.style.map(style => <Badge> {style} </Badge>)}
                </div>
              </div>
            </div>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setSelectedRecord: record => dispatch(setSelectedRecord(record)),
    };
};
 
const mapStateToProps = state => {
    return {
        selectedRecord: state.discover.selectedRecord,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscogsSearchResult);
